import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, App, Alert } from 'antd';
import { UserOutlined, LockOutlined, SafetyCertificateOutlined, BankOutlined } from '@ant-design/icons';
import request from '../utils/request';
import './Login.css';

const Login = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await request.post('/auth/login', { ...values, loginType: 'admin' });
      if (response.code === 200) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        message.success('登录成功');
        setTimeout(() => {
          navigate('/dashboard');
        }, 300);
      } else {
        message.error(response.message || '登录失败');
      }
    } catch (error) {
      message.error(error.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-left">
        <div className="login-brand">
          <div className="brand-icon">
            <BankOutlined style={{ fontSize: 64, color: '#fff' }} />
          </div>
          <h1 className="brand-title">物业访客管理系统</h1>
          <p className="brand-subtitle">Property Visitor Management System</p>
          <div className="brand-features">
            <div className="feature-item">
              <span className="feature-icon">🏢</span>
              <span>小区管理</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">👥</span>
              <span>用户管理</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📋</span>
              <span>访客预约</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>扫码核销</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="login-right">
        <Card className="login-card" variant="borderless">
          <div className="login-header">
            <div className="login-logo">
              <BankOutlined style={{ fontSize: 32, color: '#1890ff' }} />
            </div>
            <h2 className="login-title">管理后台登录</h2>
            <p className="login-desc">请输入管理员账号信息</p>
          </div>
          
          <Alert
            message="仅限系统管理人员登录"
            description="本系统仅对管理员开放，访客请使用小程序"
            type="info"
            showIcon
            icon={<SafetyCertificateOutlined />}
            style={{ marginBottom: 24, borderRadius: 8 }}
          />
          
          <Form
            name="login"
            onFinish={handleLogin}
            autoComplete="off"
            size="large"
          >
            <Form.Item
              name="phone"
              rules={[{ required: true, message: '请输入手机号' }]}
            >
              <Input
                prefix={<UserOutlined style={{ color: '#909399' }} />}
                placeholder="管理员手机号"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: '#909399' }} />}
                placeholder="登录密码"
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading} 
                block 
                size="large"
                style={{ height: 48, fontSize: 16 }}
              >
                登录管理后台
              </Button>
            </Form.Item>
          </Form>

          <div className="login-footer">
            <SafetyCertificateOutlined /> 权限验证：仅admin和manager角色可登录
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Login;
